/** @jsx jsx */
import { jsx } from '@emotion/core'
import { FunctionComponent, HTMLAttributes } from 'react'
import { styles } from './styles'
import { Checkbox } from '../checkbox'

// @ts-ignore
interface CheckboxGroupProps extends HTMLAttributes<HTMLDivElement> {
  label: string
  selected: string | number
  options: { name: string; value: string | number }[]
  onChange: (value: string | number) => any
  required?: boolean
  disabled?: boolean
}

export const CheckboxGroup: FunctionComponent<CheckboxGroupProps> = ({
  label,
  selected,
  options,
  onChange,
  required,
  tabIndex,
  disabled,
  ...props
}) => (
  <div css={[styles.container]} {...props}>
    <label css={styles.label}>
      {label} {required && <span css={styles.required}>*</span>}
    </label>

    <div css={[styles.content, disabled && styles.disabled]}>
      {options.map((option, i) => (
        <Checkbox
          label={option.name}
          checked={option.value === selected}
          bold={option.value === selected}
          onChange={(checked) => checked && onChange(option.value)}
          key={option.value}
          tabIndex={tabIndex + i}
        />
      ))}
    </div>
  </div>
)
